import { useTranslation } from "react-i18next";

import type { ProductListSortValue } from "../types";

type SortByOptions = {
  value: ProductListSortValue;
  label: string;
};

export const useSortByOptions = (): SortByOptions[] => {
  const { t } = useTranslation("product", {
    keyPrefix: "productListPage.filters.sortByOptions"
  });

  return [
    {
      value: "a-z",
      label: "A-Z"
    },
    {
      value: "z-a",
      label: "Z-A"
    },
    {
      value: "newest",
      label: t("newest")
    },
    {
      value: "oldest",
      label: t("oldest")
    },
    {
      value: "high-to-low",
      label: t("priceHighToLow")
    },
    {
      value: "low-to-high",
      label: t("priceLowToHigh")
    }
  ];
};
